import { render } from "./TenantNavigationEdit.vue?vue&type=template&id=45001f98"
import script from "./TenantNavigationEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./TenantNavigationEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Tenant/TenantNavigationEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45001f98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45001f98', __exports__)) {
    api.reload('45001f98', __exports__)
  }
  
  module.hot.accept("./TenantNavigationEdit.vue?vue&type=template&id=45001f98", () => {
    api.rerender('45001f98', render)
  })

}


export default __exports__